import {
  faArrowRightFromBracket,
  faChartSimple,
  faChevronLeft
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonAvatar,
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./player.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "../../icon/icon.png";
import { relative } from "path";
import stats_table_ball_icon from "../../icon/player/1_Equipo2.svg";
import { dom } from "@fortawesome/fontawesome-svg-core";

const Player: React.FC = () => {
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();
  const urlParams = new URLSearchParams(window.location.search);

  const [showProgessBar, setShowProgessBar] = useState(true);

  //declared outside to make it global and used it on the page

  useEffect(() => {
    // show slider
    //start the page
    mainController.init();
    // let coffee_tools = new coffeeTools();

    // console.log(coffee_tools.test(123));
  }, []);

  var controller = (() => {
    function getPlayer(callback) {
      fetch(base_url + "/sports/players/single", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: urlParams.get("player_id")
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }
    return {
      getPlayer: (callback) => getPlayer(callback)
    };
  })();

  let view = (() => {
    let dom_obj = {
      players_title: "js__teams_detail_players_title",
      players_list: "js__teams_detail_players_list",
      team_detail_card_logo: "js__team_detail_card_logo",
      team_detail_card_logo_img: "js__team_detail_card_logo_img",
      player_card_img: "js__player_card_img",
      player_card_team_logo_small: "js__player_card_team_logo_small",
      player_card_title: "js__player_card_title",
      player_card_subtitle: "js__player_card_subtitle",
      player_card_number: "js__player_card_number",
      player_border_top: "js__player_border_top",
      player_position_span: "js__player_position_span_data",
      player_number_span: "js__player_number_span_data",
      player_weight_span: "js__player_weight_span_data",
      player_altura_span: "js__player_altura_span_data",
      player_clase_span: "js__player_clase_span_data"
    };

    // tools and helpers
    function createSectionTitles(title, dom_obj_id) {
      let container = document.getElementById(dom_obj_id);
      container.innerHTML = "";
      coffee_tools.createSectionTitle(title, container);
    }

    // players list
    function showPlayer(response) {
      console.log("this si show player");
      console.log(response);

      // set background color for team logo and player photo
      let team_detail_card_logo = document.getElementById(
        dom_obj.team_detail_card_logo
      );
      team_detail_card_logo.style.backgroundColor =
        response.item.team.team_color;

      // set team logo
      let team_logo = document.getElementById(
        dom_obj.team_detail_card_logo_img
      );
      team_logo.setAttribute(
        "src",
        base_url + response.item.team.full_url_logo
      );
      team_logo.style.backgroundColor = response.item.team.team_color;

      let team_logo_small = document.getElementById(
        dom_obj.player_card_team_logo_small
      );
      team_logo_small.setAttribute(
        "src",
        base_url + response.item.team.full_url_logo
      );

      // set player photo
      let player_photo = document.getElementById(dom_obj.player_card_img);
      player_photo.setAttribute("src", base_url + response.item.full_url_image);
      // show player team name
      let player_team_name = document.getElementById(dom_obj.player_card_title);
      player_team_name.innerHTML = response.item.team.name;
      // shoe player name
      let player_name = document.getElementById(dom_obj.player_card_subtitle);
      player_name.innerHTML = response.item.name;
      // show player number
      let player_number = document.getElementById(dom_obj.player_card_number);
      player_number.innerHTML = "#" + response.item.number;

      // stats table
      document.getElementById(dom_obj.player_border_top).style.backgroundColor =
        response.item.team.team_color;

      // player position
      let player_position = document.getElementById(
        dom_obj.player_position_span
      );
      if (response.item.position == null || response.item.position == "") {
        player_position.innerHTML = "N/D";
      } else {
        player_position.innerHTML = response.item.position;
      }

      // player number
      let player_number_span = document.getElementById(
        dom_obj.player_number_span
      );
      if (response.item.number == null || response.item.number == "") {
        player_number_span.innerHTML = "N/D";
      } else {
        player_number_span.innerHTML = response.item.number;
      }

      // player weight
      let player_weight_span = document.getElementById(
        dom_obj.player_weight_span
      );
      if (response.item.weight == null || response.item.weight == "") {
        player_weight_span.innerHTML = "N/D";
      } else {
        player_weight_span.innerHTML = response.item.weight;
      }

      // player height
      let player_altura_span = document.getElementById(
        dom_obj.player_altura_span
      );
      if (response.item.height == null || response.item.height == "") {
        player_altura_span.innerHTML = "N/D";
      } else {
        player_altura_span.innerHTML = response.item.height;
      }

      // player class
      let player_clase_span = document.getElementById(
        dom_obj.player_clase_span
      );
      if (response.item.class == null || response.item.class == "") {
        player_clase_span.innerHTML = "N/D";
      } else {
        player_clase_span.innerHTML = response.item.class;
      }
    }

    return {
      dom_obj: dom_obj,
      createSectionTitles: (title, dom_obj_id) =>
        createSectionTitles(title, dom_obj_id),
      showPlayer: (response) => showPlayer(response)
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        // console.log("Menu started");
        setupEventListeners();

        // hide progress bar
        setShowProgessBar(false);

        // show players
        page_controller.getPlayer(page_view.showPlayer);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <section
          id='js__teams_detail_players'
          className='section-player-detail-half'
        >
          <div
            id='js__team_detail_card'
            className='team_detail_card'
          >
            <div className='clearfix team_detail_card_detail'>
              <div
                id='js__team_detail_card_logo'
                className='player_detail_card--logo'
              >
                <img
                  id='js__team_detail_card_logo_img'
                  className='player_team_logo'
                  alt='LNBP'
                />
                <img
                  id='js__player_card_img'
                  className='player_photo'
                  alt='LNBP'
                />
              </div>
              <img
                id='js__player_card_team_logo_small'
                className='player_card_team_logo_small'
                alt=''
              />
              <div
                id='js__player_card_title'
                className='player-card-title'
              ></div>
              <div
                id='js__player_card_subtitle'
                className='player-card-subtitle'
              ></div>
              <div
                id='js__player_card_number'
                className='player-card-number'
              ></div>
            </div>
          </div>
        </section>
        <section id='js__player_stats'>
          <div
            id='js__main_table'
            className='player_main_table'
          >
            <hr
              id='js__player_border_top'
              className='player_table_border_top'
            />
            <div
              id='js__player_position'
              className='stats-table--player-position'
            >
              <img
                src={stats_table_ball_icon}
                alt='ball'
              />
            </div>
            <span
              id='js__player_position_span'
              className='player-stats-table--data'
            >
              <span>Posición</span>
              <span id='js__player_position_span_data'></span>
            </span>
            <div id='js__player_number'>
              <span
                id='js__player_number_span'
                className='player-stats-table--data'
              >
                <span>Número</span>
                <span id='js__player_number_span_data'>#33</span>
              </span>
            </div>
            <div id='js__player_weight'>
              <span
                id='js__player_weight_span'
                className='player-stats-table--data'
              >
                <span>Peso</span>
                <span id='js__player_weight_span_data'>12kg</span>
              </span>
            </div>
            <div id='js__player_height'>
              <span
                id='js__player_altura_span'
                className='player-stats-table--data'
              >
                <span>Altura</span>
                <span id='js__player_altura_span_data'>1.5mts</span>
              </span>
            </div>
            <div id='js__player_class'>
              <span
                id='js__player_clase_span'
                className='player-stats-table--data'
              >
                <span>Clase</span>
                <span id='js__player_clase_span_data'>Desddlantero</span>
              </span>
            </div>
          </div>
        </section>
      </IonContent>
    </IonPage>
  );
};

export default Player;
